var map = {
	"./alabama-rural-studio/hero.jpg": 53,
	"./cambridge-student-accommodation/hero.jpg": 54,
	"./crescent-extension/hero.jpg": 55,
	"./dukes-park-renovation/hero.jpg": 56,
	"./hall-farm-holiday-lets/hero.jpg": 57,
	"./hall-farm-threshing-barn/hero.jpg": 58,
	"./long-road-student-centre/hero.jpg": 59,
	"./new-mills-incubator/hero.jpg": 60,
	"./sussex-street-mixed-use/hero.jpg": 61,
	"./willow-walk-remodelling/hero.jpg": 62
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 148;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects ^\.\/.*\/hero\.jpg$
// module id = 148
// module chunks = 0